import styled from "@emotion/styled";

const Wrapper = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;
`;

export default Wrapper;
